import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
  selector: 'app-visual-messaging',
  templateUrl: './visual-messaging.component.html',
  styleUrls: ['./visual-messaging.component.css'],
  standalone: false
})
export class VisualMessagingComponent implements OnInit {
  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  active: boolean;

  constructor(private store: Store<any>, private formBuilder: FormBuilder) {}

  visualForm: FormGroup;
  visualFormSubmitted: boolean;

  ngOnInit() {
    this.visualFormSubmitted = false;
    this.active = this.line.optionsStatus.visual_messaging;
    this.initForm();
  }

  /**
   * Init form
   */
  initForm() {
    this.visualForm = this.formBuilder.group({});
    if (!this.active) {
        this.visualForm.addControl('imei', this.formBuilder.control('', [Validators.required]));
        this.visualForm.addControl('model', this.formBuilder.control('', [Validators.required]));
        this.visualForm.addControl('brand', this.formBuilder.control('', [Validators.required]));
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.visualForm.valid && this.visualFormSubmitted === false) {
      this.visualFormSubmitted = true;
      this.store.dispatch(
          new SaveMission(
              {
                  step: 1,
                  active : !this.line.optionsStatus.visual_messaging,
                  phoneNumber: this.line.phoneNumber,
                  imei: !this.active ? this.visualForm.get('imei').value : null,
                  model: !this.active ? this.visualForm.get('model').value : null,
                  brand: !this.active ? this.visualForm.get('brand').value : null,
              },
              this.procedureCode
          )
      );
    }
  }
}
